import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router';

export const useFlashNotice = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const [notice, setNotice] = useState(() => (location.state as { notice?: string } | null)?.notice ?? '');

  useEffect(() => {
    if ((location.state as { notice?: string } | null)?.notice) {
      navigate({ pathname: location.pathname, search: location.search }, { replace: true, state: null });
    }
  }, [location, navigate]);

  return [notice, setNotice] as const;
};
